'use strict';
const mmWidgets = require('./mm-widgets');

require('./section-handler-widget');
require('./show-progress-message');
require('./show-error');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.addInsPurchaseWidget = function ({subscriptionAddInsModel, subscriptionModel}) {
	if (!subscriptionAddInsModel || !subscriptionModel) {
		throw new Error('invalid-args');
	}
	let task, previewedAddInId, previewedQuantity;
	return mmWidgets.each(this, function () {
		const element = this.sectionHandlerWidget(),
			authoriseButton = element.find('[data-mm-role~="authorise-payment"]'),
			cancelButton = element.find('[data-mm-role~="cancel-task"]'),
			confirmButton = element.find('[data-mm-role~="confirm"]'),
			invoiceTable = element.find('[data-mm-role~="invoice"]'),
			invoiceItemTemplate = invoiceTable.find('[data-mm-role~="invoice-template-line"]').detach(),
			purchase = () => {
				if (!previewedAddInId) {
					element.showError('no-active-add-in');
					return;
				}
				return subscriptionAddInsModel.purchase(previewedAddInId, previewedQuantity);
			},
			showPreview = (preview) => {
				const previewItems = (preview && preview.lines) || [],
					total = preview.total || previewItems.reduce((currentValue, item) => currentValue + item.amount, 0),
					currency = preview.currency || (previewItems && previewItems.length && previewItems[0].currency),
					totalItem = {description: 'Total to pay now', amount: total, currency: currency};
				invoiceTable.empty();
				previewItems.push(totalItem);
				previewItems.forEach((item) => {
					const line = invoiceItemTemplate.clone(),
						amount = new Number(item.amount).toFixed(2);
					line.find('[data-mm-role~="invoice-description"]').text(item.description);
					line.find('[data-mm-role~="invoice-amount"]').text(`${amount} ${item.currency}`);
					invoiceTable.append(line);
				});
				trackEvent({
					action: 'popup_opened',
					popup_type: 'add_in_purchase',
					currency: currency,
					value: total
				});
				element.showSection('preview');
				element.trigger('showPreviewComplete');
			};
		authoriseButton.click(() => {
			element.showSection('payment-authorisation-progress');
		});
		cancelButton.click(() => {
			if (task) {
				return task.cancel();
			}
		});
		subscriptionAddInsModel.addEventListener('purchaseInProgress', () => element.showProgressMessage('Contacting your payment provider...'));

		subscriptionAddInsModel.addEventListener('purchaseStatus', (newStatus) => element.showSection(newStatus));

		subscriptionAddInsModel.addEventListener('purchaseAuthUrl', (actionUrl) => authoriseButton.attr('href', actionUrl));

		subscriptionAddInsModel.addEventListener('loadingAddInPreview', () => {
			element.removeClass('hidden');
			element.showProgressMessage('Preparing, please wait...');
		});
		subscriptionAddInsModel.addEventListener('loadedAddInPreview', ({addInId, preview, quantity}) => {

			previewedAddInId = addInId;
			previewedQuantity = quantity;
			showPreview(preview);
		});
		confirmButton.click(purchase);
	});

};
